exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-a0b32502],html[data-v-a0b32502]{height:100%}img[data-v-a0b32502]{max-width:400px}", ""]);

// exports
